import {Grid, Typography,Card,CardContent} from '@material-ui/core';
import {generateOutline,OUTLINE_UTILS} from '../../utility';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en'

function OutlineBrief({briefInfo}){
    const timeAgo = new TimeAgo('en-US');

    const getPublishedDate = (competitorDate) => {
        try{
            const formattedDate =  timeAgo.format(new Date(competitorDate));
            return formattedDate;
        }catch(err) {
            return;
        }
    }

    const css = `
        .brief-outline .MuiGrid-root{
            margin-left: 0 !important;
        }
        .brief-outline .MuiAccordionDetails-root, .brief-outline .MuiAccordionSummary-root{
            padding: 0 !important;
        }
    `;

    return(
        <div className="brief-outline">
            <style>{css}</style>
            <Grid item xs="12" style={{backgroundColor:'white',padding:'0rem'}}>
            <Card>
                <Grid container xs="12"  direction="row" spacing={1} style={{padding:'1rem'}}>
                    <Grid item xs="12" style={{marginBottom:'1rem',position:'sticky',position:'-webkit-sticky',top:'0'}}> 
                        <Typography variant="subtitle2" display="block" style={{fontWeight:'800',color:'#334152'}}>{OUTLINE_UTILS.HEADER_TEXT}</Typography>
                        <Typography variant="caption" display="block" style={{color:'#334152'}}>{OUTLINE_UTILS.DESCRIPTION_TEXT_1} <a href="https://usetopic.zendesk.com/hc/en-us/articles/360051872774">{OUTLINE_UTILS.DESCRIPTION_TEXT_2}</a></Typography>
                    </Grid>
                    {(briefInfo.report && briefInfo.report.competitors) ? 
                        (briefInfo.report.competitors).map((competitor) => {
                            return(
                                <Grid item xs="12" md="12" alignItems="center" direction="row" style={{marginBottom:20}}>
                                    <Card >
                                        <CardContent style={{backgroundColor:'#f2f4f8'}}>
                                            <Typography variant="caption">{`Position ${competitor.position} / Content Grade ${competitor.grade} / Published ${getPublishedDate(competitor.date)}`}</Typography>
                                        </CardContent>
                                        <CardContent>
                                            <Typography variant="subtitle2" style={{color:'#3e4b5b', fontWeight:'bold',marginTop:'0.5rem'}}><img class="topic-detail-outline-icon" src={`https://www.google.com/s2/favicons?domain_url=${competitor.url}`} style={{verticalAlign:'middle',marginRight:'0.2rem'}}></img>{competitor.title.substring(0, 60) + "..."}</Typography>
                                            <a href={competitor.url}>{(competitor.url).split('/')[0] + '//' + (competitor.url).split('/')[2]}</a>
                                        </CardContent>
                                        {(competitor.description)? 
                                        <CardContent>
                                            <Typography variant="subtitle2" style={{fontWeight:'700',color:'#859fbd'}}>{OUTLINE_UTILS.OUTLINE_DESCRIPTION_TEXT}</Typography>
                                            <Typography variant="caption">{competitor.description}</Typography>
                                        </CardContent>
                                        : null}
                                        <CardContent style={{overflow: 'auto',scrollbarWidth: 'none'}}>
                                            <Typography variant="subtitle2" style={{fontWeight:'700',color:'#859fbd', marginBottom: '6px'}}>{OUTLINE_UTILS.OUTLINE_OUTLINE_TEXT}</Typography>
                                            <Grid style={{margin:'1rem 1rem'}}>
                                            {(competitor.headings).map((headings) =>
                                                generateOutline(headings.text,headings.tag)
                                            )}
                                            </Grid>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            );
                        })
                    : 
                    null
                    }
                    </Grid>
                </Card>
            </Grid>
        </div>
    );

}

export default OutlineBrief;